/* ==========================================================================
   RENZALO — Transitions entre les sections au scroll
   Chaque section principale (sauf la première, visible dès le chargement)
   apparaît avec un fondu + une légère translation quand elle entre dans
   le viewport. Couvre aussi bien le contenu principal que le footer.
   Respecte prefers-reduced-motion.
   ========================================================================== */

(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collectSections() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var footer = document.querySelector('footer');
    var nodes = [];
    if (main) nodes = nodes.concat(Array.prototype.slice.call(main.querySelectorAll('.shopify-section')));
    if (footer) nodes = nodes.concat(Array.prototype.slice.call(footer.querySelectorAll('.shopify-section')));
    return nodes;
  }

  function revealAll() {
    collectSections().forEach(function (section) {
      section.classList.add('renzalo-section--visible');
      section.classList.remove('renzalo-section--reveal');
    });
  }

  function initSectionReveal() {
    var sections = collectSections();
    if (!sections.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // threshold 0 + small margin: short sections at the very end of the page
    // (e.g. footer utilities) must still be able to trigger the reveal.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('renzalo-section--visible');
            entry.target.classList.remove('renzalo-section--reveal');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach(function (section, index) {
      if (section.classList.contains('renzalo-section--visible') || section.dataset.rzSectionObserved) return;

      var rect = section.getBoundingClientRect();
      var alreadyInView = rect.top < viewportHeight * 0.85;

      if (index === 0 || alreadyInView) {
        section.classList.add('renzalo-section--visible');
        return;
      }

      section.dataset.rzSectionObserved = 'true';
      section.classList.add('renzalo-section--reveal');
      observer.observe(section);
    });
  }

  // Safety net: once the visitor reaches the bottom of the page, show every
  // remaining section so nothing can stay invisible.
  function revealAtBottom() {
    var scrolled = window.scrollY + (window.innerHeight || document.documentElement.clientHeight);
    if (scrolled >= document.documentElement.scrollHeight - 80) revealAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSectionReveal);
  } else {
    initSectionReveal();
  }

  window.addEventListener('load', function () {
    setTimeout(initSectionReveal, 50);
  });

  window.addEventListener('scroll', revealAtBottom, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.classList && event.target.classList.contains('shopify-section')
      ? event.target
      : null;
    if (section) {
      section.classList.add('renzalo-section--visible');
    } else {
      // A section was added/reordered elsewhere (e.g. footer group in the
      // editor) — re-scan for any newly rendered sections.
      initSectionReveal();
    }
  });
})();

/* Renzalo: "+1 hinzufügen" under a cart line presses that line's own plus
   button, so the theme updates the cart and the Mengenrabatt applies. */
document.addEventListener('click', function (event) {
  var button = event.target instanceof Element ? event.target.closest('[data-rz-cart-plus]') : null;
  if (!button) return;
  var row = button.closest('tr');
  var plus = row ? row.querySelector('button[name="plus"]') : null;
  if (!plus) return;
  button.disabled = true;
  plus.click();
});

/* Renzalo: "+ Hinzufügen" on cart suggestions adds the product without
   leaving the cart. Same flow as the theme's product form: announce a
   CartLinesUpdateEvent and resolve it with the re-rendered cart sections. */
document.addEventListener('click', async function (event) {
  var button = event.target instanceof Element ? event.target.closest('[data-rz-cart-add]') : null;
  if (!button) return;
  button.disabled = true;

  var variantId = Number(button.getAttribute('data-rz-cart-add'));
  var sectionIds = Array.prototype.map
    .call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; })
    .filter(Boolean);

  try {
    var events = await import('@shopify/events');
    var deferred = events.CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    var response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') }),
    }).then(function (r) { return r.json(); });

    var cart = await fetch(Theme.routes.cart_url + '.js').then(function (r) { return r.json(); });
    deferred.resolve({
      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'rz-cart-recos',
        itemCount: 1,
        sections: response.sections,
        didError: Boolean(response.status),
      },
    });
  } catch (error) {
    window.location.reload();
  }
});
